import { createContext, useContext, Dispatch, SetStateAction } from "react";

// Define the shape of the context
interface RoleContextType {
  role: string[];
  setRole: Dispatch<SetStateAction<string[]>>;
  dfnsToken: string | null;
  setDfnsToken: Dispatch<SetStateAction<string | null>>;
  user: any;
  setUser: Dispatch<SetStateAction<any>>;
}

// Provide default values that align with the interface
const defaultContext: RoleContextType = {
  role: [],
  setRole: () => {},
  dfnsToken: null,
  setDfnsToken: () => {},
  user: null,
  setUser: () => {},
};

// Create and export the RoleContext with the defined type
export const RoleContext = createContext<RoleContextType>(defaultContext);

// Optional: Create a custom hook for easier consumption
export const useRoleContext = () => useContext(RoleContext);

// The reviewer role grants read-only access to every page. It is appended to a
// user's roles by the `setUserAsReviewer` cloud function (lowercase "reviewer").
export const REVIEWER_ROLE = "reviewer";

// True when the current session has the reviewer role, meaning all mutating
// controls across the app must be hidden.
export const useIsReviewer = (): boolean => {
  const { role } = useContext(RoleContext);
  return Array.isArray(role) && role.includes(REVIEWER_ROLE);
};

// True when the current session has the admin role, which some cloud functions require on their own.
export const useIsAdmin = (): boolean => {
  const { role } = useContext(RoleContext);
  return Array.isArray(role) && role.includes("admin");
};
